import React from "react";

const Footer = () => {
  return (
    <footer className="py-6 text-center bg-white dark:bg-[#1A1A1A] text-sm text-gray-500 dark:text-gray-400">
      © {new Date().getFullYear()} EthioCare. All rights reserved.
    </footer>
  );
};

export default Footer;
